import { useMutation } from "@tanstack/react-query";
import { generateGoogleBusinessProfileDescription } from "../../api/bReviewsApi";

export const useGenerateGoogleBusinessProfileDescription = () => {
  return useMutation({
    mutationKey: ["generate-google-business-profile-description"],
    mutationFn: ({ locationId, data }) =>
      generateGoogleBusinessProfileDescription(locationId, data),
  });
};
